import React from 'react';
import { Row, Col } from 'reactstrap';

const CapabilityScores = (props) => {
    // legend config
    const legend = [
        { range: "0.00 - 1.00", label: "Severe", color: "#d73027", textColor: "#fff" },
        { range: "1.00 - 2.00", label: "Very High", color: "#ffae7a", textColor: "#000" },
        { range: "2.00 - 3.00", label: "Moderate", color: "#ffe687", textColor: "#000" },
        { range: "3.00 - 4.00", label: "Low", color: "#d9ef8b", textColor: "#000" },
        { range: "4.00 - 5.00", label: "Nominal", color: "#60b17e", textColor: "#fff" },
    ];

    // score cards
    let gridItem = props.scores.map((score, key) => {
        let iconClass = "far fa-check-circle";
        let statLabel = "Complete";
        let box = 1;

        if (score.status === "2") {
            iconClass = "far fa-clock";
            statLabel = "In Progress";
            box = 2;
        }
        if (score.status === "1") {
            iconClass = "far fa-times-circle";
            statLabel = "Not Started";
            box = 3;
        }

        return (
            <Col xl key={'scoreStat' + key} className={`mb-4 box-width box-sec-${box}`}>
                <div className="card shadow h-100 py-2 bg-white">
                    <div className="card-body">
                        <Row className="no-gutters text-center">
                            <div className="col">
                                <span><i className={iconClass}></i></span>
                            </div>
                            <div className="col-8">
                                <h5 className="h5 mb-0">{score.count}</h5>
                                <p className="text-xs mb-1">{statLabel}</p>
                            </div>
                        </Row>
                    </div>
                </div>
            </Col>
        );
    });

    return (
        <>
            {/* Heatmap legend pills row */}
            {props.showLegend && (
                <Row className="heatmap-legend mb-3 justify-content-center">
                    {legend.map((item, idx) => (
                        <Col key={idx} xs="auto" className="mb-2">
                            <span
                                style={{
                                    backgroundColor: item.color,
                                    color: item.textColor,
                                    padding: "6px 14px",
                                    borderRadius: "20px",
                                    fontSize: "13px",
                                    fontWeight: "500",
                                    display: "inline-block",
                                    whiteSpace: "nowrap"
                                }}
                            >
                                {item.range} → {item.label}
                            </span>
                        </Col>
                    ))}
                </Row>
            )}

            {/* Score cards row */}
            <Row className="business-decomposition-box-sec mt-2">
                {gridItem}
            </Row>
        </>
    );
};

export default CapabilityScores;
